import type { CustomerModel } from "@/core/customer/models";
import { request } from "@/lib/api/request-api.client";

export type Appointment = {
  id: string;
  userSnapshot?: { name: string; email: string } | null;
  title: string;
  customerSnapshot?: CustomerModel | null;
  notes: string | null;
  startsAt: string;
  endsAt: string;
  status: "scheduled" | "completed" | "not_completed" | "cancelled";
  outcome: string | null;
  opportunityId: string | null;
};

export type NewAppointment = {
  title: string;
  customerSnapshot?: CustomerModel | null;
  notes?: string;
  opportunityId?: string;
  startsAt: string;
  endsAt: string;
};

export async function listAppointments(from: Date, to: Date) {
  const params = new URLSearchParams({
    from: from.toISOString(),
    to: to.toISOString(),
  });
  return (
    await request({ url: `/v1/crm/appointments?${params}`, method: "GET" })
  ).map((result) => (result.data as { data: Appointment[] }).data);
}

export async function createAppointment(data: NewAppointment) {
  return (
    await request({ url: "/v1/crm/appointments", method: "POST", data })
  ).map((result) => (result.data as { data: Appointment }).data);
}

export async function rescheduleAppointment(
  id: string,
  startsAt: string,
  endsAt: string,
  details?: {
    title: string;
    notes?: string;
    customerSnapshot?: CustomerModel | null;
  },
) {
  return (
    await request({
      url: `/v1/crm/appointments/${encodeURIComponent(id)}/reschedule`,
      method: "PATCH",
      data: { startsAt, endsAt, ...details },
    })
  ).map((result) => (result.data as { data: Appointment }).data);
}

export async function cancelAppointment(id: string) {
  return request({
    url: `/v1/crm/appointments/${encodeURIComponent(id)}`,
    method: "DELETE",
  });
}
